import { addHours } from './index';

/**
 * Gets the next full hour
 */
export default function getNextFullHour(dt) {
  const date = addHours(dt, 1);
  return new Date(date.setMinutes(0));
}
